module.exports = __webpack_public_path__ + "images/branding/savemyhomeusa/hd_bg.gif";